import Controller from "csi/action/Controller";
import CsiFormData from "csi/action/FormData";
import message from "csi/message";
import localeProvider from "csi/page/localeProvider";
import reflection from "csi/reflection";
import { setLocationRevisionUrl } from "csi/router";
import declare from "dojo/_base/declare";
import { createPullFromBOMStore } from "./PullFromBOMService";
import { PullFromBOMResources } from "./PullFromBOMStore";

const PullFromSourceBOMController = declare(Controller, {
	/** @override use store instead of actioncontroller */
	async onReactViewProps(props) {
		const { m_cache, m_formData, m_action } = this;
		const resource: PullFromBOMResources = {
			configureRestoreSettings: "ConfigureRestoreSettings",
			restoreSettings: "RestoreSettings",
			placementsToDelete: "PlacementsToDelete",
			placementsOnStyleBOM: "PlacementsOnSourceBOM",
			placementsToAdd: "PlacementsToAdd",
			tableSubTitleRes: "PullFromSourceBOM_TableSubTitle",
		};
		const contextNode = this.getNode() || this.getParent();
		const rc = reflection.getClass(contextNode.$Type);
		const contextNodeCurrentRevisionUrl = rc.isDerivedFrom("DataSheetRevision") ? contextNode.$URL : contextNode.CurrentRevision;
		props.store = createPullFromBOMStore(
			m_action.getId(),
			m_cache,
			m_formData,
			contextNodeCurrentRevisionUrl,
			props.onClose,
			props.onSave,
			localeProvider,
			resource,
		);
	},

	/** @override */
	onFormData(fd: CsiFormData): void {
		fd.m_bRequireOne = true;
		fd.m_bSelectOne = true;
	},

	/**
	 * @override
	 * Navigate to current revision and then force to show status message after
	 */
	postProcessSuccess(): void {
		const bomRevision = this.m_cache.getNode(this.m_urlParent);
		const bom = this.m_cache.getNode(bomRevision.__Parent__);
		const revisionURL = bom.CurrentRevision;
		// this will hide the success message due a mobx reaction for the selected layout item changing, so we need to show it again
		setLocationRevisionUrl(revisionURL).then(() => message.success(this.getSuccess()));
	},
});

export = PullFromSourceBOMController;
